<template>
  <div
    class="modal-alert sticky-actions enable"
    :data-show-at-position="showAtPosition"
    :data-show-only-on-scroll-up="showOnlyOnScrollUp"
    @click="showModal"
  >
    <div class="grid-flex grid-middle grid-no-response">
      <div class="grid-item-shrink modal-alert-img">
        <img :src="imageUrl">
      </div>
      <div class="modal-content grid-item">
        <p>
          {{ content }}
        </p>
      </div>
      <div class="grid-item-shrink">
        <DuiIconArrowRight class="icon-white space-right-2em" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    content: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      required: true,
    },
    modalId: {
      type: String,
      required: true,
    },
    showAtPosition: {
      type: String,
      required: true,
    },
    showOnlyOnScrollUp: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    showModal() {
      Vue.prototype.exitModalHandler.initAndShow(this.modalId);
    },
  },
};
</script>
